export default __webpack_public_path__ + "static/media/passwordRecovery.1e24aecc.svg";